var map = {
  "./shape-triangle-aquamarine-gradient.png": "117839",
  "./shape-triangle-aquamarine-light.png": "650979",
  "./shape-triangle-aquamarine.png": "88961",
  "./shape-triangle-blue-gradient.png": "913590",
  "./shape-triangle-blue-light.png": "890432",
  "./shape-triangle-blue.png": "286436",
  "./shape-triangle-cyan-gradient.png": "347695",
  "./shape-triangle-cyan-light.png": "390898",
  "./shape-triangle-cyan.png": "340892",
  "./shape-triangle-green-gradient.png": "22991",
  "./shape-triangle-green-light.png": "295680",
  "./shape-triangle-green.png": "748270",
  "./shape-triangle-grey100.png": "809905",
  "./shape-triangle-grey1000.png": "320960",
  "./shape-triangle-grey200.png": "579825",
  "./shape-triangle-grey25.png": "529490",
  "./shape-triangle-grey300.png": "713764",
  "./shape-triangle-grey400.png": "162077",
  "./shape-triangle-grey50.png": "981161",
  "./shape-triangle-grey500.png": "282000",
  "./shape-triangle-grey600.png": "528148",
  "./shape-triangle-grey700.png": "382761",
  "./shape-triangle-grey800.png": "471702",
  "./shape-triangle-grey900.png": "405206",
  "./shape-triangle-indigo-gradient.png": "314861",
  "./shape-triangle-indigo-light.png": "470985",
  "./shape-triangle-indigo.png": "391609",
  "./shape-triangle-lime-gradient.png": "48890",
  "./shape-triangle-lime-light.png": "877482",
  "./shape-triangle-lime.png": "220402",
  "./shape-triangle-magenta-gradient.png": "490108",
  "./shape-triangle-magenta-light.png": "576602",
  "./shape-triangle-magenta.png": "400311",
  "./shape-triangle-navy-gradient.png": "920187",
  "./shape-triangle-navy-light.png": "957650",
  "./shape-triangle-navy.png": "455216",
  "./shape-triangle-orange-gradient.png": "411271",
  "./shape-triangle-orange-light.png": "128153",
  "./shape-triangle-orange.png": "521491",
  "./shape-triangle-purple-gradient.png": "960158",
  "./shape-triangle-purple-light.png": "700479",
  "./shape-triangle-purple.png": "186114",
  "./shape-triangle-red-gradient.png": "417824",
  "./shape-triangle-red-light.png": "596462",
  "./shape-triangle-red.png": "421553",
  "./shape-triangle-yellow-gradient.png": "748671",
  "./shape-triangle-yellow-light.png": "750343",
  "./shape-triangle-yellow.png": "239226"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52440;
